import { createAction, props } from '@ngrx/store';

export const checkAutopayEligibility = createAction(
  '[Payment Confirmation Component] Check Autopay Eligibility',
  props<{
    tenantId: string;
    accountNumbers: string[];
  }>(),
);

export const enrollInAutopayClicked = createAction(
  '[Payment Confirmation Component] Enroll In Autopay Clicked',
);
